document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-variant-selector input").forEach((el) => {
    el.addEventListener("change", () => {
      selectedVariantId = el.dataset.variantId;
      form = el.offsetParent.querySelector("product-form");
      const idInput = form.querySelector('input[name="id"]');
      idInput.value = selectedVariantId;
    });
  });
});